import React from "react";
import { Box, Typography } from "@mui/material";
import SectionFrame from "../SectionFrame";
import { EditableText } from "../InlineEditable";
import EditableImage from "../EditableImage";
import { resolveLandingAssetUrl } from "../../../../utils/landingAssets";

export default function BrandsSection({ form, active, device, productsEnabled, onSelect, onCommit, onCommitMany, onUploadImage, onRemoveImage, disabled }) {
  const isMobile = device === "mobile";
  const copy = form.catalog.brands || {};
  const brands = Array.isArray(copy.items) ? copy.items : [];
  const primary = form.theme.primaryColor || "#F35A3A";
  const secondary = form.theme.secondaryColor || "#19242F";
  const enabled = productsEnabled && form.sections.showProducts !== false && form.sections.showBrands !== false;
  const toggle = (next) => onCommitMany
    ? onCommitMany({ "sections.showProducts": true, "sections.showBrands": next })
    : onCommit("sections.showBrands", next);
  const samples = brands.length ? brands.slice(0, 8) : Array.from({ length: isMobile ? 4 : 6 }, (_, index) => ({ name: `Marca ${index + 1}`, logoUrl: "" }));

  return (
    <SectionFrame id="brands" label="Marcas" active={active} enabled={enabled} onSelect={onSelect} onToggle={productsEnabled ? toggle : undefined}>
      <Box sx={{ px: isMobile ? 2.2 : 5.5, py: isMobile ? "var(--wp-space-48)" : "var(--wp-space-64)", bgcolor: form.theme.surfaceColor || "#fff" }}>
        <Box sx={{ maxWidth: 1280, mx: "auto", textAlign: "center" }}>
          <EditableText value={copy.eyebrow} fallback="Marcas" disabled={disabled} onSave={(value) => onCommit("catalog.brands.eyebrow", value)} sx={{ color: primary, textTransform: "uppercase", letterSpacing: 1.2, fontWeight: 900, fontSize: 13 }} />
          <Box sx={{ mt: 0.5 }}><EditableText value={copy.title} fallback="Marcas" disabled={disabled} onSave={(value) => onCommit("catalog.brands.title", value)} sx={{ color: secondary, fontWeight: "var(--wp-segment-title-weight)", fontSize: isMobile ? "var(--wp-title-34)" : "var(--wp-title-44)", letterSpacing: "var(--wp-segment-letter-spacing)" }} /></Box>
          <Box sx={{ mt: 1, mx: "auto", maxWidth: 720 }}><EditableText value={copy.subtitle} fallback="Elegí una marca y explorá el catálogo disponible." disabled={disabled} multiline onSave={(value) => onCommit("catalog.brands.subtitle", value)} sx={{ color: form.theme.mutedTextColor || "#5B5D73", lineHeight: 1.7 }} /></Box>
          <Box sx={{ mt: 3.5, display: "grid", gridTemplateColumns: isMobile ? "repeat(2,minmax(0,1fr))" : "repeat(6,minmax(0,1fr))", gap: 1.4 }}>
            {samples.slice(0, 6).map((brand, index) => {
              const actual = Boolean(brands[index]);
              const logo = resolveLandingAssetUrl(brand.logoUrl);
              return (
                <Box key={`${brand.name}-${index}`} sx={{ minHeight: 100, p: 1.1, border: "1px solid rgba(25,36,47,.10)", borderRadius: 3, bgcolor: "#fff", display: "grid", placeItems: "center", boxShadow: "0 8px 22px rgba(25,36,47,.05)" }}>
                  {actual ? (
                    <EditableImage
                      value={brand.logoUrl}
                      label={brand.name || `Marca ${index + 1}`}
                      helperText="Logo limpio y preferentemente transparente. Evitá márgenes vacíos excesivos."
                      height={74}
                      disabled={disabled}
                      onUpload={(file) => onUploadImage(`catalog.brands.items.${index}.logoUrl`, file, { sectionKey: "brands", assetKey: `brand-${index + 1}` })}
                      onRemove={() => onRemoveImage(`catalog.brands.items.${index}.logoUrl`)}
                      sx={{ width: "100%", minHeight: 74, bgcolor: "#fff", backgroundSize: "contain", backgroundRepeat: "no-repeat", borderColor: "rgba(25,36,47,.12)", transform: "scale(var(--wp-segment-image-scale))" }}
                    />
                  ) : logo ? (
                    <Box component="img" src={logo} alt={brand.name} sx={{ maxWidth: "100%", maxHeight: 64, objectFit: "contain" }} />
                  ) : (
                    <Typography variant="body2" sx={{ fontWeight: 900, color: "rgba(25,36,47,.48)" }}>{brand.name}</Typography>
                  )}
                </Box>
              );
            })}
          </Box>
          {!brands.length ? <Typography variant="caption" sx={{ display: "block", mt: 2, color: "rgba(25,36,47,.5)" }}>Los logos reales se agregan desde Ajustes → Recursos visuales.</Typography> : null}
        </Box>
      </Box>
    </SectionFrame>
  );
}
